import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

@Injectable()
export class ArquivosService {

  constructor(http: HttpClient,
    private utilService: UtilService,
    private gestaoPcaService: GestaoPcaService) {
  }

  // lista as peças obrigatorias, cadastradas no SAP
  public listarPecasProcessuaisObrigatoria(pcdModuloPCA): Observable<any> {
    let urlObtencaoDados = "arquivo/listarPecasProcessuaisObrigatorias?idPca=" + this.gestaoPcaService.getPCA().id + "&flObrigatorio=true&idModuloPca=" + pcdModuloPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  // lista as peças obrigatorias, cadastradas no SAP
  public listarPecasProcessuaisObrigatoriasPorPcaPorModulo(pcdModulo): Observable<any> {
    let urlObtencaoDados = "arquivo/listarPecasProcessuaisObrigatoriasPorPcaPorModulo?idPca=" + this.gestaoPcaService.getPCA().id + "&flObrigatorio=true&idModulo=" + pcdModulo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  // lista as peças não obrigatorias, cadastradas no SAP
  public listarPecasProcessuaisNObrigatoria(pcdModuloPCA): Observable<any> {
    let urlObtencaoDados = "arquivo/listarPecasProcessuaisObrigatorias?idPca=" + this.gestaoPcaService.getPCA().id + "&flObrigatorio=false&idModuloPca=" + pcdModuloPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarPecasVinculadasPCAPorTipoAnalise(pcdModuloPCA, pcdTipoAnalise) {
    let urlObtencaoDados = "arquivo/listarArquivosVinculadosTipoAnalise/"+ pcdModuloPCA + "/" + pcdTipoAnalise;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarArquivosVinculadosPorModuloPcaPorTipoDocumento(idModuloPCA: any, listaTipoDocumentos: any, isSefaz: boolean) {
    let urlObtencaoDados = "arquivo/listarArquivosVinculadosPorModuloPcaPorTipoDocumento/" + idModuloPCA + "/"+ listaTipoDocumentos + "/" + isSefaz;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarPecasVinculadasPCA(pidProcesso, pcdModuloPCA, pcdTipoAnalise,flPegaDocumentoDoModuloDeContrato) {
    let urlObtencaoDados = "arquivo/listarArquivosVinculados/" + this.gestaoPcaService.getPCA().id + "/" + pidProcesso + "/" + pcdModuloPCA + "/" + pcdTipoAnalise+ "/" + flPegaDocumentoDoModuloDeContrato;
    return this.utilService.getJSON(urlObtencaoDados);
  }
  
  public salvarModuloPecasProcessuais(jsonObjeto, idModuloPCA, idModuloAnalise): Observable<any> {
    let urlObtencaoDados = "arquivo/salvarModuloPecasProcessuais?idModuloPca=" + idModuloPCA + "&idPca=" + this.gestaoPcaService.getPCA().id + "&idModuloAnalise=" + idModuloAnalise;
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public finalizarModuloPecasProcessuais(jsonObjeto, idModuloPCA, idModuloAnalise): Observable<any> {
    let urlObtencaoDados = "arquivo/finalizarModuloPecasProcessuais?idModuloPca=" + idModuloPCA + "&idPca=" + this.gestaoPcaService.getPCA().id + "&idModuloAnalise=" + idModuloAnalise;
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public listarPecasProcessuaisAssinaveis(idModuloPca: any, idModulo: any, exercicio: any, idEntidade: any, idTipoEntidadeExercicio: any, idTipoDocumento: any): Observable<any> {
    let urlObtencaoDados = "arquivo/listarArquivosAssinaveis?idPca=" + this.gestaoPcaService.getPCA().id + "&idModuloPca=" + idModuloPca + "&idModulo=" + idModulo + "&exercicio=" + exercicio + "&idEntidade=" + idEntidade + "&idTipoEntidadeExercicio=" + idTipoEntidadeExercicio+ "&idTipoDocumento=" + idTipoDocumento;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterPorModuloPcaPorTipoEntidadePorTipoDocumento(idModuloPca, idTipoEntidadeExercicio, idTipoDocumento): Observable<any> {
    let urlObterQuestoes = "arquivo/obterPorModuloPcaPorTipoEntidadePorTipoDocumento?idModuloPca=" + idModuloPca + "&idTipoEntidadeExercicio=" + idTipoEntidadeExercicio + "&idTipoDocumento="+idTipoDocumento;
    return this.utilService.getJSON(urlObterQuestoes);
  }


  //justificativa
  // Cadastro dos Contratos de Gestao
  public obterJustificativa(idModuloPCA, idModuloPecaSap): Observable<any> {
    let urlObterQuestoes = "pecaJustificativa/listar?idModuloPca=" + idModuloPCA + "&idModuloPecaSap=" + idModuloPecaSap;
    return this.utilService.getJSON(urlObterQuestoes);
  }

  public deletarJustificativa(id) {
    let urlObtencaoDados: string = "pecaJustificativa/deletar/" + id;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public salvarJustificativa(jsonObjeto): Observable<any> {
    let urlObterQuestoes = "pecaJustificativa/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(urlObterQuestoes, jsonObjeto);
  }

}



// WEBPACK FOOTER //
// ./src/providers/arquivos-service.ts